import { Component, ElementRef, HostListener, OnInit } from "@angular/core";
import { getApp } from "../app";

@Component({
  selector: "app-dates-filter",
  templateUrl: "./dates-filter.component.html",
  styleUrl: "./dates-filter.component.scss",
})
export class DatesFilterComponent implements OnInit {
  app = getApp((app) => {
    this.app = app;
  });

  ngOnInit(): void {}

  constructor(private elementRef: ElementRef) {}

  // Listen for all document clicks
  @HostListener("document:mousedown", ["$event"])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.app.datesFilter.showComponent = false;
      // this.app.datesFilter.clear();
    }
  }

  onDateModeChange(mode: string) {
    if (mode === "interval") {
      const hasManufacturerFrom = this.app.filterHeaderTable.filters.some(
        (f) => f.filterLabelField === "manufacturer.lastUpdatedOn"
      );
      this.app.datesFilter.model.specificDate = null;
      if (hasManufacturerFrom) {
        this.app.filterHeaderTable.clearFilter(
          this.app.fieldId.manufacturer.lastUpdatedOn
        );
      }
    }
    if (mode === "specific") {
      this.app.datesFilter.model.fromDate = null;
      this.app.datesFilter.model.toDate = null;
      const hasManufacturerFrom = this.app.filterHeaderTable.filters.some(
        (f) => f.filterLabelField === "manufacturer.from"
      );
      if (hasManufacturerFrom) {
        this.app.filterHeaderTable.clearLastUpdatedOnFilter();
      }
    }
  }

  onApply() {
    if (this.app.datesFilter.model.dateMode === "specific") {
      this.app.filterHeaderTable.filter(
        this.app.fieldId.manufacturer.lastUpdatedOn,
        this.app.datesFilter.model.specificDate
      );
    } else {
      let obj = {
        "manufacturer.from": this.app.datesFilter.model.fromDate,
        "manufacturer.to": this.app.datesFilter.model.toDate,
      };
      this.app.filterHeaderTable.filterLastUpdatedOn(obj);
    }
    this.app.datesFilter.showComponent = false;
  }
}
